import React from "react";
import FooterLogoBox from "./FooterLogoBox";
import FooterLinksBox from "./FooterLinksBox";
import FooterContactUsInfoBox from "./FooterContactUsInfoBox";
import SocialLinks from "../socialLinks/SocialLinks";
import {MaskGroupFooter} from "../../assets/icons";
import {useSettings} from "../../hooks/SettingsContext";
import {useLanguage} from "../../hooks/LanguageContext";
import DOMPurify from "dompurify";

const Footer = () => {
	const settings = useSettings();
	const { direction } = useLanguage(); // Get the direction from LanguageContext
	const sanitizedFooterTextAr = DOMPurify.sanitize(settings?.footer_ar, {
		ALLOWED_ATTR: ["class"],
	});
	const sanitizedFooterTextEn = DOMPurify.sanitize(settings?.footer_en, {
		ALLOWED_ATTR: ["class"],
	});
	return (
		<footer className='bg-bg-darken mt-[100px] h-full'>
			<section className='container'>
				<div className='relative flex md:flex-row flex-col justify-around items-start md:py-[90px] py-12'>
					<FooterLogoBox />

					<section className='md:w-[920px] w-full flex md:flex-row flex-col items-start justify-between gap-20'>
						<FooterLinksBox />
						{settings && <FooterContactUsInfoBox data={settings} />}
					</section>

					{settings && (
						<SocialLinks
							links={settings}
							position={direction === "rtl" ? "xl:left-0 lg:left-0 left-0 bottom-[10rem]" : "xl:right-0 lg:right-0 right-0 bottom-[10rem]"}
						/>
					)}

				</div>
			</section>

			<section className='relative md:py-[30px] py-4 border-t-[1px] border-grayscale-100'>

				<p
					className="w-full text-center text-lg font-medium leading-[28.8px]"
					dangerouslySetInnerHTML={{
						__html:
							direction === "rtl" && sanitizedFooterTextAr
								? sanitizedFooterTextAr
								: sanitizedFooterTextEn
					}}
				>
				</p>


				<MaskGroupFooter className='hidden md:block absolute  md:bottom-0 bottom-0 md:left-0 left-auto md:right-auto -right-20 md:w-[126px] md:h-[60px] h-[40px]' />
			</section>
		</footer>
	);
};

export default Footer;
